import React, { useEffect, useState } from "react";
import PackageSelector from "../packageSelector/packageSelector";
import { fetchWithAuth } from "../../../auth/auth";
import { getApiUrl } from "../../../utils/getApiUrl";
import { BaseModal } from "../../../components/modalCommon/modalBase";
import { ModalHeader } from "../../../components/modalCommon/modalHeader";
import { ModalBody } from "../../../components/modalCommon/modalBody";
import "./changePackageModal.scss";

import type {
  BackendPackage,
  ChangePackageModalProps,
  PackageOption,
} from "../../../type/packages";

const ChangePackageModal: React.FC<ChangePackageModalProps> = ({
  show,
  onClose,
  currentPackageId,
  onConfirm,
}) => {
  const [packages, setPackages] = useState<PackageOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const formatLimit = (value: number): string =>
    value === -1 ? "unlimited" : value.toString();

  const normalizePrice = (
    value: number | null | undefined
  ): number | null =>
    value === null || value === undefined ? null : value;

  useEffect(() => {
    if (!show) return;

    setLoading(true);
    setError(null);

    fetchWithAuth(getApiUrl("tools/packages"))
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load packages");
        return res.json();
      })
      .then((data: BackendPackage[]) => {
        const mapped: PackageOption[] = data.map((p) => ({
          id: p.idpackage,
          name: p.name,

          dictionaries: formatLimit(p.max_dictionaries),
          expressions: formatLimit(p.max_expressions),

          price_regular: normalizePrice(p.price_regular),
          price_promo: normalizePrice(p.price_promo),

          highlight: p.name === "PRO",
        }));

        setPackages(mapped);
      })
      .catch((err) => {
        console.error(err);
        setError("Nie udało się pobrać pakietów.");
      })
      .finally(() => setLoading(false));
  }, [show]);

  return (
    <BaseModal open={show} onClose={onClose} size="lg">
      <ModalHeader title="Change Package" onClose={onClose} />

      <ModalBody>
        {loading && (
          <div className="text-center py-4">Loading packages…</div>
        )}

        {error && (
          <div className="alert alert-danger">{error}</div>
        )}

        {!loading && !error && (
          <PackageSelector
            packages={packages}
            selectedPackageId={currentPackageId}
            onSelect={onConfirm}
          />
        )}
      </ModalBody>
    </BaseModal>
  );
};

export default ChangePackageModal;
